<template>
  <div
    class="contentWrap"
    :style="{
      backgroundImage:
        'url(' +
        $returnColor().path +
        ($store.state.selfData.member_id
          ? '/home-page_bg.png'
          : '/home-page_bg.png') +
        ')',
    }"
  >
    <van-popup v-model="showAddWallet" round position="bottom">
      <van-picker
        show-toolbar
        :columns="walletList"
        @cancel="showAddWallet = false"
        @confirm="selectWallet"
      >
        <template #title>
          <van-button
            size="small"
            type="primary"
            @click="
              addWalletDialog = true;
              addWalletData = {};
            "
            >新增地址</van-button
          >
        </template>
        <template #option="item">
          <div
            style="display: flex; justify-content: space-between; width: 90%"
          >
            <p>{{ item.alias }} - {{ item.addr }}</p>
            <p @click="delWallet(item)">
              <van-icon name="delete-o" />
            </p>
          </div>
        </template>
      </van-picker>
    </van-popup>
    <van-dialog
      v-model="addWalletDialog"
      title="绑定钱包"
      show-cancel-button
      :before-close="beforeAddWallet"
    >
      <van-form>
        <van-field
          v-model="addWalletData.addr"
          label="地址"
          placeholder="地址"
        />
        <van-field
          v-model="addWalletData.alias"
          label="别名"
          placeholder="别名"
        />
      </van-form>
    </van-dialog>
    <van-dialog
      :before-close="beforeUpload"
      v-model="uploadFileModal"
      show-cancel-button
      title="文件上传"
    >
      <van-form>
        <van-field
          readonly
          clickable
          name="picker"
          :value="orderData.amount"
          label="金额"
          placeholder="金额"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="orderData.rate"
          label="汇率"
          placeholder="汇率"
        />
        <van-field
          v-model="addr"
          center
          clearable
          label="发送地址"
          placeholder="发送地址"
        >
          <template #button>
            <van-button
              size="small"
              type="primary"
              @click="showAddWallet = true"
              >选择地址</van-button
            >
          </template>
        </van-field>

        <van-field
          clickable
          name="picker"
          :value="orderData.usdt"
          label="需打款USDT"
          placeholder="USDT"
        />
        <van-field name="uploader" label="上传文件">
          <template #input>
            <van-uploader
              :before-read="comversionImg"
              :before-delete="deleteImgList"
              accept="/*"
              v-model="files"
              :max-count="3"
            />
          </template>
        </van-field>
      </van-form>
    </van-dialog>
    <van-dialog
      v-model="USDTModal"
      title="USDT充值"
      show-cancel-button
      :before-close="confirmDepositUSDT"
      confirmButtonText="下一步"
    >
      <p style="color: red; font-size: 14px; text-align: center">
        实际金额以付款页面为主
      </p>
      <van-cell-group inset style="width: 285px">
        <van-cell :title="'汇率'" :value="depositData.rate"> </van-cell>
        <van-cell
          :title="'约需打款USDT'"
          :value="returnNum(amount / depositData.rate)"
        >
        </van-cell>
        <van-field
          style="border-radius: 0px 0px 8px 8px"
          inset
          v-model="captcha2"
          center
          clearable
          label="验证码"
          placeholder="请输入验证码"
        >
          <template #button>
            <img :src="captchaData2.img" alt="" @click="getCaptcha2" />
          </template>
        </van-field>
      </van-cell-group>
    </van-dialog>
    <div class="">
      <van-dialog
        v-model="orderModal"
        title="USDT充值"
        show-cancel-button
        :beforeClose="updateUSDTFiles"
        :cancelButtonColor="$returnColor().color2"
        cancelButtonText="上传文件"
      >
        <van-cell-group inset style="width: 285px">
          <van-cell :title="'金额'" :value="orderData.amount"> </van-cell>
          <van-cell :title="'汇率'" :value="orderData.rate"> </van-cell>
          <van-cell
            title="需打款USDT"
            v-clipboard:copy="String(orderData.usdt)"
            v-clipboard:success="onCopy"
          >
            <template #default>
              <p style="margin-right: 5px">
                {{ orderData.usdt }}
              </p>
            </template>
            <template #right-icon>
              <i class="far fa-clone copyIcon" style="margin-left: 5px"></i>
            </template>
          </van-cell>
          <van-cell
            v-clipboard:copy="String(orderData.usdt)"
            v-clipboard:success="onCopy"
          >
            <template #title>
              <p style="color: red; font-size: 14px">
                打款金额必须一致，否则无法到账
              </p>
            </template>
          </van-cell>

          <van-cell
            title="打款地址"
            v-clipboard:copy="String(orderData.addr)"
            v-clipboard:success="onCopy"
          >
            <template #default>
              <p style="margin-right: 5px">
                {{ orderData.addr }}
              </p>
            </template>
            <template #right-icon>
              <i class="far fa-clone copyIcon" style="margin-left: 5px"></i>
            </template>
          </van-cell>
          <van-cell :title="'备注'" :value="orderData.note"> </van-cell>
        </van-cell-group>
        <div style="display: flex; justify-content: center">
          <!-- <vue-qrcode :value="orderData.addr" :width="200" /> -->
        </div>
      </van-dialog>
    </div>
    <!-- top -->
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" title="充值申请" left-arrow>
        <template #right>
          <p @click="$router.push('/depositRecord')">申请纪录</p>
        </template>
      </van-nav-bar>
    </van-sticky>
    <!-- top -->
    <div class="content">
      <div class="wrap">
        <div
          class="seletWrap"
          v-if="
            $store.state.selfData.can_deposit_usdt == 1 &&
            $store.state.selfData.can_deposit == 1
          "
        >
          <div class="left" :class="{ active: type == 1 }" @click="type = 1">
            <p>人民币充值</p>
          </div>
          <div class="right" :class="{ active: type == 2 }" @click="type = 2">
            <p>USDT充值</p>
          </div>
        </div>
        <van-form style="width: 295px; margin-top: 24px">
          <van-field
            v-if="type == 1 || $store.state.selfData.can_deposit_usdt != 1"
            style="border-radius: 8px 8px 0 0"
            inset
            v-model="realName"
            type="text"
            name="真实姓名"
            label="真实姓名"
            placeholder="真实姓名"
            :rules="[{ required: true, message: '请填写真实姓名' }]"
          />
          <van-field
            v-model="amount"
            type="number"
            name="充值金额"
            label="金额(人民币)"
            placeholder="充值金额"
            :rules="[{ required: true, message: '请填写充值金额' }]"
          />
          <van-field
            style="border-radius: 0px 0px 8px 8px"
            inset
            v-model="captcha"
            center
            clearable
            label="验证码"
            placeholder="请输入验证码"
          >
            <template #button>
              <img :src="captchaData.img" alt="" @click="getCaptcha" />
            </template>
          </van-field>
          <div style="display: flex; justify-content: center; margin-top: 15px">
            <van-button
              color="linear-gradient(to right, #ff6034, #ee0a24)"
              @click="sendDeposit"
            >
              申请充值
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>
<script>
// import VueQrcode from "vue-qrcode";
// import { Notify } from "vant";
import * as imageConversion from "image-conversion";
export default {
  components: {
    // VueQrcode,
  },
  data() {
    return {
      captchaTime: 120000,
      captchaTimeOut: "",
      captchaData: {},
      captcha: "",
      captchaData2: {},
      captcha2: "",
      files: [],
      type: 1,
      realName: "",
      bankList: [],
      showAddWallet: false,
      amount: "",
      allBank: [],
      USDTModal: false,
      depositData: {},
      orderModal: false,
      orderData: {},
      uploadFileModal: false,
      addWalletData: {},
      addWalletDialog: false,
      addr: "",
      walletList: [],
      httpFiles: [],
      isHttps: window.location.protocol === "https:",
    };
  },
  methods: {
    getCaptcha() {
      clearTimeout(this.captchaTimeOut);
      this.captcha = "";
      this.$http.get(`/mobile/captcha`).then((res) => {
        if (res.data.code == 0) {
          this.captchaData = res.data.data;
          this.captchaTimeOut = setTimeout(() => {
            this.getCaptcha();
          }, this.captchaTime);
        }
      });
    },
    getCaptcha2() {
      this.captcha2 = "";
      this.$http.get(`/mobile/captcha`).then((res) => {
        if (res.data.code == 0) {
          this.captchaData2 = res.data.data;
        }
      });
    },
    deleteImgList(file, detail) {
      if (!this.isHttps) {
        this.httpFiles.splice(detail.index, 1);
      }
      return true;
    },
    delWallet(e) {
      const vm = this;
      this.$dialog.confirm({
        title: "删除钱包",
        message: `${e.alias}-${e.addr}`,
        beforeClose(method, done) {
          if (method == "confirm") {
            vm.$http.delete(`/mobile/wallets/${e.id}`).then((res) => {
              if (res.data.code == 0) {
                vm.$toast.success("删除成功");
                vm.getwallets();
              }
            });
          }
          done();
        },
      });
    },
    selectWallet(e) {
      this.addr = e.addr;
      this.showAddWallet = false;
    },
    beforeAddWallet(method, done) {
      if (method == "confirm") {
        this.$http.post(`/mobile/wallets`, this.addWalletData).then((res) => {
          if (res.data.code == 0) {
            this.$toast.success("成功");
            this.getwallets();
            done();
          } else {
            done(false);
          }
        });
      } else {
        done();
      }
    },
    returnNum(num) {
      return num.toFixed(2);
      // .substring(0, String(num).length - 1);
    },
    comversionImg(files) {
      this.$store.dispatch("setLoadding", true);

      let allFile = Array.isArray(files) ? files : [files];

      const convertedList = Promise.all(
        allFile.map((file) => {
          // 影片不壓縮，直接返回
          if (file.type.indexOf("video") !== -1) {
            return Promise.resolve(file);
          }

          // 圖片進行壓縮
          return imageConversion
            .compressAccurately(file, 1000)
            .then((compressed) => {
              return compressed;
            })
            .catch((err) => {
              this.$toast.fail("请检查文件格式");
              console.error("壓縮錯誤：", err);
              return null;
            });
        })
      )
        .then(async (results) => {
          const validFiles = results.filter((f) => f !== null);

          if (!this.isHttps) {
            const uploadPromises = validFiles.map((file) => {
              const formData = new FormData();
              formData.append("image", file);

              return this.$http
                .post("/doupload", formData)
                .then((res) => {
                  const success = res?.data?.success;
                  if (success === true) {
                    this.httpFiles.push(res.data.url);
                    return file;
                  } else {
                    alert(JSON.stringify(res, null, 2));
                    this.$toast.fail("上传失败 请再试一次");
                    return null;
                  }
                })
                .catch((err) => {
                  alert(JSON.stringify(err, null, 2));
                  console.error("上传错误：", err);
                  return null;
                });
            });

            const uploaded = await Promise.all(uploadPromises);
            const finalList = uploaded.filter((u) => u !== null);

            this.$store.dispatch("setLoadding", false);
            return finalList;
          }

          this.$store.dispatch("setLoadding", false);
          // 若為 HTTPS，返回壓縮後的 File 物件
          return validFiles;
        })
        .catch((err) => {
          this.$store.dispatch("setLoadding", false);
          console.error("處理錯誤：", err);
          return [];
        });

      return convertedList;
    },
    beforeUpload(method, done) {
      if (method == "confirm") {
        if (!this.addr) {
          this.$toast.fail("请输入地址");
          done(false);
          return;
        }

        var formData = new FormData();
        if (!this.isHttps) {
          this.httpFiles.forEach((e) => {
            formData.append("files[]", e);
          });
          formData.append("byPath", 1);
        } else {
          this.files.forEach((e) => {
            formData.append("files[]", e.file);
          });
        }
        formData.append("addr", this.addr);
        this.$http
          .post(`/mobile/deposit/${this.orderData.order_id}/check`, formData)
          .then((res) => {
            if (res.data.code == 0) {
              this.orderModal = false;
              this.$toast.success("成功");
              done();
            } else {
              done(false);
            }
          });
      } else {
        done();
      }
    },
    updateUSDTFiles(method, done) {
      if (method == "confirm") {
        done();
      } else {
        this.files = [];
        this.httpFiles = [];
        done(false);
        this.uploadFileModal = true;
      }
    },
    onCopy() {
      this.$toast.success("已复制");
    },
    confirmDepositUSDT(method, done) {
      let vm = this;
      if (method == "confirm") {
        if (!vm.captcha2) {
          vm.$toast.fail("请输入验证码");
          done(false);
          return;
        }
        vm.$http
          .post(`/mobile/deposit`, {
            usdt: 1,
            addr_id: vm.depositData.id,
            amount: vm.amount,
            captcha: vm.captcha2,
            key: vm.captchaData2.key,
          })
          .then((res) => {
            if (res.data.code == 0) {
              vm.orderModal = true;
              vm.orderData = res.data.data;
              done();
            } else {
              vm.getCaptcha2();
              done(false);
            }
          });
      } else {
        done();
      }
    },
    onClickLeft() {
      this.$router.push("/");
    },
    sendDeposit() {
      let vm = this;
      let params = {
        captcha: this.captcha,
        key: this.captchaData.key,
        amount: this.amount,
      };
      if (!this.captcha) {
        vm.$toast.fail("请输入验证码");
        return;
      }
      if (this.type == 2 && this.$store.state.selfData.can_deposit_usdt == 1) {
        this.$http.get(`/mobile/usdt`, { params }).then((res) => {
          if (res.data.code == 0) {
            this.getCaptcha2();
            this.USDTModal = true;
            this.depositData = res.data.data;
          } else {
            this.getCaptcha();
          }
        });
        return;
      }
      this.$dialog.confirm({
        title: "充值",
        message: `充值金额: ${this.amount}`,
        beforeClose(method, done) {
          if (method == "confirm") {
            vm.$http
              .post(`/mobile/deposit`, {
                amount: vm.amount,
                real_name: vm.realName,
                captcha: vm.captcha,
                key: vm.captchaData.key,
              })
              .then((res) => {
                if (res.data.code == 0) {
                  vm.$toast.success("申请成功");
                  let link = res.data.data.pay_url;
                  const someCallback = function (url) {
                    setTimeout(() => {
                      window.open(url, "redirect");
                      location.href = link;
                    });
                  };
                  someCallback(link);
                } else {
                  vm.getCaptcha();
                }
              });
          }
          done();
        },
      });
    },
    getwallets() {
      this.$http.get(`/mobile/wallets`).then((res) => {
        if (res.data.code == 0) {
          this.walletList = res.data.data;
        }
      });
    },
  },
  computed: {
    selfData() {
      return this.$store.state.selfData;
    },
  },
  watch: {
    selfData() {
      if (this.selfData.can_deposit != 1) {
        this.type = 2;
      }
    },
  },
  created() {
    this.getCaptcha();
    if (this.selfData.username) {
      if (this.selfData.can_deposit != 1) {
        this.type = 2;
      }
    }
    this.getwallets();
  },
  destroyed() {
    clearTimeout(this.captchaTimeOut);
  },
};
</script>
<style lang="scss" scoped>
.seletWrap {
  width: 240px;
  height: 34px;
  display: flex;
  border-radius: 50px;
  margin: 0 auto;
  overflow: hidden;
  background-color: #fff;

  .left,
  .right {
    width: 50%;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      text-align: center;
      margin: 0;
    }
  }

  .left.active,
  .right.active {
    background: linear-gradient(to right, rgb(255, 96, 52), rgb(238, 10, 36));
    color: white;
  }
}

.content {
  padding: 0 20px;
  display: flex;
  justify-content: center;
}

.contentWrap {
  // background-image: url("/home-page_bg.png");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  // background-attachment: fixed;
  min-height: 100vh;
}
</style>
